import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';

/* ── ícone reutilizável ── */
const Icon = ({ d, size = 16, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);

const ICONS = {
  chevron: 'M19 9l-7 7-7-7',
  filter:  'M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z',
  cash:    'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
  chart:   'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  dre:     'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  ticket:  'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z',
  users:   'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
  empty:   'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
};

/* ── helpers de estilo ── */
const inputStyle = {
  width: '100%', padding: '8px 12px', borderRadius: '8px',
  border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
  fontFamily: "'Inter','Segoe UI',sans-serif", outline: 'none',
  backgroundColor: '#fff', boxSizing: 'border-box',
  transition: 'border-color 0.15s, box-shadow 0.15s',
};
const focusHandlers = {
  onFocus: e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.1)'; },
  onBlur:  e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; },
};
const FieldLabel = ({ children }) => (
  <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '4px' }}>
    {children}
  </label>
);

/* ── accordion nativo ── */
const AccordionSection = ({ title, icon, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '10px' }}>
      <button
        type="button" onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 18px', border: 'none', cursor: 'pointer',
          background: open ? 'linear-gradient(135deg, #eff6ff, #f8fafc)' : '#f9fafb',
          fontFamily: 'inherit', transition: 'background 0.15s',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <Icon d={icon} size={14} color="#2563eb" />
          <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>{title}</span>
        </div>
        <div style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
          <Icon d={ICONS.chevron} size={14} color="#6b7280" />
        </div>
      </button>
      {open && (
        <div style={{ padding: '18px 20px', backgroundColor: '#fff', borderTop: '1px solid #f1f5f9' }}>
          {children}
        </div>
      )}
    </div>
  );
};

/* ── barra de filtros ── */
const FilterBar = ({ children, onFilter, isLoading, filterLabel = 'Gerar' }) => (
  <div style={{
    display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end',
    marginBottom: '16px', padding: '14px 16px',
    backgroundColor: '#f8fafc', borderRadius: '10px', border: '1px solid #f1f5f9',
  }}>
    {children}
    <div style={{ marginLeft: 'auto' }}>
      <button
        type="button" onClick={onFilter} disabled={isLoading}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          padding: '8px 16px', borderRadius: '8px', border: 'none',
          background: isLoading ? '#93c5fd' : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
          color: '#fff', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600',
          cursor: isLoading ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
        }}
      >
        {isLoading
          ? <Spinner as="span" animation="border" size="sm" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />
          : <Icon d={ICONS.filter} size={11} color="#fff" />
        }
        {isLoading ? 'Gerando...' : filterLabel}
      </button>
    </div>
  </div>
);

/* ── loading ── */
const LoadingRow = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px', gap: '10px' }}>
    <Spinner animation="border" variant="primary" style={{ width: '24px', height: '24px' }} />
    <span style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#6b7280' }}>Carregando...</span>
  </div>
);

/* ── empty state ── */
const EmptyState = ({ message }) => (
  <div style={{ padding: '36px 24px', textAlign: 'center' }}>
    <Icon d={ICONS.empty} size={26} color="#d1d5db" />
    <p style={{ margin: '8px 0 0', fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af', fontWeight: '500' }}>{message}</p>
  </div>
);

/* ── estilos de th/td ── */
const thStyle = {
  padding: '9px 13px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#64748b',
  textTransform: 'uppercase', letterSpacing: '0.4px',
  borderBottom: '2px solid #e2e8f0', background: 'linear-gradient(135deg,#f8fafc,#f1f5f9)',
  textAlign: 'left', whiteSpace: 'nowrap',
};
const tdStyle = { padding: '10px 13px', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle' };

/* ── linha de tabela de fluxo ── */
const FluxoRow = ({ label, value, formatCurrency, indent = false, highlight, colorValue }) => (
  <tr style={{ backgroundColor: highlight || 'transparent' }}>
    <td style={{ ...tdStyle, paddingLeft: indent ? '2.5em' : '13px', color: indent ? '#6b7280' : '#374151', fontWeight: highlight ? '700' : '400' }}>
      {label}
    </td>
    <td style={{ ...tdStyle, textAlign: 'right', fontWeight: highlight ? '700' : '400', color: colorValue || (highlight ? '#111827' : '#374151') }}>
      {value !== undefined ? formatCurrency(value) : ''}
    </td>
  </tr>
);

/* ── KPI card para ticket médio / retenção ── */
const KpiCard = ({ label, value, sub }) => (
  <div style={{
    backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb',
    padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '4px',
  }}>
    <span style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</span>
    <span style={{ fontSize: '22px', fontWeight: '800', color: '#111827', lineHeight: 1.2 }}>{value}</span>
    {sub && <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af' }}>{sub}</span>}
  </div>
);

/* ════════════════════════════════════════════════════════ */

const RelatoriosGerenciaisTab = ({ currentEntidade, formatCurrency, isActive }) => {

  /* ── fluxo de caixa ── */
  const [fluxoCaixaData,            setFluxoCaixaData]            = useState(null);
  const [isLoadingFluxoCaixa,       setIsLoadingFluxoCaixa]       = useState(false);
  const [filtroDataInicioFluxo,     setFiltroDataInicioFluxo]     = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
  const [filtroDataFimFluxo,        setFiltroDataFimFluxo]        = useState(new Date().toISOString().split('T')[0]);

  /* ── DRE ── */
  const [dreData,                   setDreData]                   = useState(null);
  const [isLoadingDre,              setIsLoadingDre]              = useState(false);
  const [filtroDataInicioDre,       setFiltroDataInicioDre]       = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
  const [filtroDataFimDre,          setFiltroDataFimDre]          = useState(new Date().toISOString().split('T')[0]);

  /* ── análise de custos ── */
  const [analiseCustosDespesasData, setAnaliseCustosDespesasData] = useState(null);
  const [isLoadingAnaliseCustos,    setIsLoadingAnaliseCustos]    = useState(false);
  const [filtroDataInicioAnaliseCustos, setFiltroDataInicioAnaliseCustos] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
  const [filtroDataFimAnaliseCustos,    setFiltroDataFimAnaliseCustos]    = useState(new Date().toISOString().split('T')[0]);

  /* ── ticket médio ── */
  const [ticketMedioData,           setTicketMedioData]           = useState(null);
  const [isLoadingTicketMedio,      setIsLoadingTicketMedio]      = useState(false);
  const [filtroDataInicioTicketMedio, setFiltroDataInicioTicketMedio] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
  const [filtroDataFimTicketMedio,    setFiltroDataFimTicketMedio]    = useState(new Date().toISOString().split('T')[0]);

  /* ── taxa de retenção ── */
  const [taxaRetencaoData,          setTaxaRetencaoData]          = useState(null);
  const [isLoadingTaxaRetencao,     setIsLoadingTaxaRetencao]     = useState(false);
  const [filtroDataInicioRetencaoP1, setFiltroDataInicioRetencaoP1] = useState(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toISOString().split('T')[0]);
  const [filtroDataFimRetencaoP1,    setFiltroDataFimRetencaoP1]    = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 0).toISOString().split('T')[0]);
  const [filtroDataInicioRetencaoP2, setFiltroDataInicioRetencaoP2] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
  const [filtroDataFimRetencaoP2,    setFiltroDataFimRetencaoP2]    = useState(new Date().toISOString().split('T')[0]);

  /* ── fetches ── */
  const fetchFluxoCaixa = async () => {
    if (!filtroDataInicioFluxo || !filtroDataFimFluxo || !currentEntidade) return;
    setIsLoadingFluxoCaixa(true);
    try {
      const r = await axios.get('/api/relatorios/financeiro/fluxo-caixa', {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioFluxo, data_fim: filtroDataFimFluxo },
      });
      setFluxoCaixaData(r.data);
    } catch { setFluxoCaixaData(null); }
    finally { setIsLoadingFluxoCaixa(false); }
  };

  const fetchDre = async () => {
    if (!filtroDataInicioDre || !filtroDataFimDre || !currentEntidade) return;
    setIsLoadingDre(true);
    try {
      const r = await axios.get('/api/relatorios/financeiro/dre', {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioDre, data_fim: filtroDataFimDre },
      });
      setDreData(r.data);
    } catch { setDreData(null); }
    finally { setIsLoadingDre(false); }
  };

  const fetchAnaliseCustos = async () => {
    if (!filtroDataInicioAnaliseCustos || !filtroDataFimAnaliseCustos || !currentEntidade) return;
    setIsLoadingAnaliseCustos(true);
    try {
      const r = await axios.get('/api/relatorios/financeiro/analise-custos-despesas', {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioAnaliseCustos, data_fim: filtroDataFimAnaliseCustos },
      });
      setAnaliseCustosDespesasData(r.data);
    } catch { setAnaliseCustosDespesasData(null); }
    finally { setIsLoadingAnaliseCustos(false); }
  };

  const fetchTicketMedio = async () => {
    if (!filtroDataInicioTicketMedio || !filtroDataFimTicketMedio || !currentEntidade) return;
    setIsLoadingTicketMedio(true);
    try {
      const r = await axios.get('/api/relatorios/financeiro/ticket-medio', {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioTicketMedio, data_fim: filtroDataFimTicketMedio },
      });
      setTicketMedioData(r.data);
    } catch { setTicketMedioData(null); }
    finally { setIsLoadingTicketMedio(false); }
  };

  const fetchTaxaRetencao = async () => {
    if (!filtroDataInicioRetencaoP1 || !filtroDataFimRetencaoP1 || !filtroDataInicioRetencaoP2 || !filtroDataFimRetencaoP2 || !currentEntidade) return;
    setIsLoadingTaxaRetencao(true);
    try {
      const r = await axios.get('/api/relatorios/financeiro/taxa-retencao', {
        params: { entidade_id: currentEntidade.id, data_inicio_p1: filtroDataInicioRetencaoP1, data_fim_p1: filtroDataFimRetencaoP1, data_inicio_p2: filtroDataInicioRetencaoP2, data_fim_p2: filtroDataFimRetencaoP2 },
      });
      setTaxaRetencaoData(r.data);
    } catch { setTaxaRetencaoData(null); }
    finally { setIsLoadingTaxaRetencao(false); }
  };

  useEffect(() => {
    if (isActive && currentEntidade) {
      fetchFluxoCaixa(); fetchDre(); fetchAnaliseCustos(); fetchTicketMedio(); fetchTaxaRetencao();
    }
  }, [isActive, currentEntidade,
      filtroDataInicioFluxo, filtroDataFimFluxo,
      filtroDataInicioDre, filtroDataFimDre,
      filtroDataInicioAnaliseCustos, filtroDataFimAnaliseCustos,
      filtroDataInicioTicketMedio, filtroDataFimTicketMedio,
      filtroDataInicioRetencaoP1, filtroDataFimRetencaoP1,
      filtroDataInicioRetencaoP2, filtroDataFimRetencaoP2]);

  /* ── RENDER ── */
  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');`}</style>

      {/* ══ Fluxo de Caixa ══ */}
      <AccordionSection title="Fluxo de Caixa" icon={ICONS.cash} defaultOpen>
        <FilterBar onFilter={fetchFluxoCaixa} isLoading={isLoadingFluxoCaixa}>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Início</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataInicioFluxo} onChange={e => setFiltroDataInicioFluxo(e.target.value)} {...focusHandlers} />
          </div>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Fim</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataFimFluxo} onChange={e => setFiltroDataFimFluxo(e.target.value)} {...focusHandlers} />
          </div>
        </FilterBar>

        {isLoadingFluxoCaixa ? <LoadingRow /> : !fluxoCaixaData ? (
          <EmptyState message="Nenhum dado de fluxo de caixa para o período." />
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '10px', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
              <thead>
                <tr>
                  <th style={thStyle}>Descrição</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Valor (R$)</th>
                </tr>
              </thead>
              <tbody>
                <FluxoRow label="Saldo Inicial (Caixa/Bancos)" value={fluxoCaixaData.saldo_inicial_caixa_bancos} formatCurrency={formatCurrency} />
                <tr><td colSpan="2" style={{ ...tdStyle, fontWeight: '700', backgroundColor: '#f8fafc', color: '#374151' }}>Entradas Operacionais</td></tr>
                {fluxoCaixaData.entradas_operacionais?.detalhes_por_origem?.map((det, idx) => (
                  <FluxoRow key={`entrada-${idx}`} label={det.origem} value={det.valor} formatCurrency={formatCurrency} indent colorValue="#16a34a" />
                ))}
                <FluxoRow label="Total Entradas Operacionais" value={fluxoCaixaData.entradas_operacionais?.total} formatCurrency={formatCurrency} highlight="#f0fdf4" colorValue="#16a34a" />
                <tr><td colSpan="2" style={{ ...tdStyle, fontWeight: '700', backgroundColor: '#f8fafc', color: '#374151' }}>Saídas Operacionais</td></tr>
                {fluxoCaixaData.saidas_operacionais?.detalhes_por_categoria?.map((det, idx) => (
                  <FluxoRow key={`saida-${idx}`} label={det.categoria} value={det.valor} formatCurrency={formatCurrency} indent colorValue="#dc2626" />
                ))}
                <FluxoRow label="Total Saídas Operacionais" value={fluxoCaixaData.saidas_operacionais?.total} formatCurrency={formatCurrency} highlight="#fef2f2" colorValue="#dc2626" />
                <FluxoRow label="Fluxo de Caixa Líquido do Período" value={fluxoCaixaData.fluxo_caixa_liquido_periodo} formatCurrency={formatCurrency} highlight="#eff6ff" colorValue="#2563eb" />
                <FluxoRow label="Saldo Final (Caixa/Bancos)" value={fluxoCaixaData.saldo_final_caixa_bancos} formatCurrency={formatCurrency} highlight="#f0fdf4" colorValue="#16a34a" />
              </tbody>
            </table>
          </div>
        )}
      </AccordionSection>

      {/* ══ DRE ══ */}
      <AccordionSection title="Demonstração do Resultado (DRE)" icon={ICONS.dre}>
        <FilterBar onFilter={fetchDre} isLoading={isLoadingDre}>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Início</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataInicioDre} onChange={e => setFiltroDataInicioDre(e.target.value)} {...focusHandlers} />
          </div>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Fim</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataFimDre} onChange={e => setFiltroDataFimDre(e.target.value)} {...focusHandlers} />
          </div>
        </FilterBar>

        {isLoadingDre ? <LoadingRow /> : !dreData ? (
          <EmptyState message="Nenhum dado de DRE para o período." />
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '10px', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
              <tbody>
                <FluxoRow label="(+) Receita Bruta de Serviços" value={dreData.receita_bruta_servicos} formatCurrency={formatCurrency} colorValue="#16a34a" />
                <FluxoRow label="(-) Deduções da Receita" value={dreData.deducoes_receita?.total} formatCurrency={formatCurrency} colorValue="#dc2626" />
                {dreData.deducoes_receita?.detalhes?.map((det, idx) => (
                  <FluxoRow key={`ded-${idx}`} label={det.descricao} value={det.valor} formatCurrency={formatCurrency} indent colorValue="#dc2626" />
                ))}
                <FluxoRow label="(=) Receita Líquida de Serviços" value={dreData.receita_liquida_servicos} formatCurrency={formatCurrency} highlight="#eff6ff" colorValue="#2563eb" />
                <FluxoRow label="(-) Custo dos Serviços Prestados (CSP)" value={dreData.custo_servicos_prestados?.total} formatCurrency={formatCurrency} colorValue="#dc2626" />
                <FluxoRow label="Materiais Diretos Utilizados" value={dreData.custo_servicos_prestados?.materiais_diretos_utilizados} formatCurrency={formatCurrency} indent colorValue="#dc2626" />
                <FluxoRow label="Mão de Obra Direta (MOD)" value={dreData.custo_servicos_prestados?.mao_de_obra_direta} formatCurrency={formatCurrency} indent colorValue="#dc2626" />
                <FluxoRow label="(=) Lucro Bruto" value={dreData.lucro_bruto} formatCurrency={formatCurrency} highlight="#f0fdf4" colorValue="#16a34a" />
                <FluxoRow label="(-) Despesas Operacionais" value={dreData.despesas_operacionais?.total} formatCurrency={formatCurrency} colorValue="#dc2626" />
                {[
                  ['Folha Pag. Administrativa',       dreData.despesas_operacionais?.folha_pagamento_administrativa],
                  ['Aluguel e Condomínio',             dreData.despesas_operacionais?.aluguel_condominio],
                  ['Água, Luz, Telefone, Internet',    dreData.despesas_operacionais?.agua_luz_telefone_internet],
                  ['Marketing e Publicidade',          dreData.despesas_operacionais?.marketing_publicidade],
                  ['Material Escritório/Limpeza',      dreData.despesas_operacionais?.material_escritorio_limpeza],
                  ['Outras Despesas Administrativas',  dreData.despesas_operacionais?.outras_despesas_administrativas],
                ].map(([label, value], idx) => (
                  <FluxoRow key={`desp-${idx}`} label={label} value={value} formatCurrency={formatCurrency} indent colorValue="#dc2626" />
                ))}
                <FluxoRow label="(=) Lucro Operacional" value={dreData.lucro_operacional} formatCurrency={formatCurrency} highlight="#eff6ff" colorValue="#2563eb" />
                <FluxoRow label="(=) Lucro Líquido do Exercício" value={dreData.lucro_liquido_exercicio} formatCurrency={formatCurrency} highlight="#f0fdf4" colorValue="#16a34a" />
              </tbody>
            </table>
          </div>
        )}
      </AccordionSection>

      {/* ══ Análise de Custos e Despesas ══ */}
      <AccordionSection title="Análise de Custos e Despesas" icon={ICONS.chart}>
        <FilterBar onFilter={fetchAnaliseCustos} isLoading={isLoadingAnaliseCustos}>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Início</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataInicioAnaliseCustos} onChange={e => setFiltroDataInicioAnaliseCustos(e.target.value)} {...focusHandlers} />
          </div>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Fim</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataFimAnaliseCustos} onChange={e => setFiltroDataFimAnaliseCustos(e.target.value)} {...focusHandlers} />
          </div>
        </FilterBar>

        {isLoadingAnaliseCustos ? <LoadingRow /> : !analiseCustosDespesasData ? (
          <EmptyState message="Nenhum dado de análise de custos para o período." />
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '10px', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
              <thead>
                <tr>
                  <th style={thStyle}>Categoria</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Valor (R$)</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>% Receita Líquida</th>
                </tr>
              </thead>
              <tbody>
                {/* Receita líquida */}
                <tr style={{ backgroundColor: '#eff6ff' }}>
                  <td style={{ ...tdStyle, fontWeight: '700', color: '#2563eb' }}>Receita Líquida Total</td>
                  <td style={{ ...tdStyle, textAlign: 'right', fontWeight: '700', color: '#2563eb' }}>{formatCurrency(analiseCustosDespesasData.total_receita_liquida)}</td>
                  <td style={tdStyle} />
                </tr>
                {/* Linhas de custo */}
                {[
                  { label: 'Custos com Materiais',                  val: analiseCustosDespesasData.custos_com_materiais?.total,       pct: analiseCustosDespesasData.custos_com_materiais?.percentual_sobre_receita_liquida, sub: null },
                  { label: 'Custos com Folha de Pagamento (Bruto)', val: analiseCustosDespesasData.custos_com_folha_pagamento?.total_bruto, pct: analiseCustosDespesasData.custos_com_folha_pagamento?.percentual_sobre_receita_liquida, sub: null },
                  { label: 'Despesas Administrativas Fixas',        val: analiseCustosDespesasData.despesas_administrativas_fixas?.total, pct: analiseCustosDespesasData.despesas_administrativas_fixas?.percentual_sobre_receita_liquida, sub: analiseCustosDespesasData.despesas_administrativas_fixas?.detalhes },
                  { label: 'Despesas Variáveis e Outras',           val: analiseCustosDespesasData.despesas_variaveis_outras?.total,  pct: analiseCustosDespesasData.despesas_variaveis_outras?.percentual_sobre_receita_liquida, sub: analiseCustosDespesasData.despesas_variaveis_outras?.detalhes },
                ].map((row, i) => (
                  <React.Fragment key={i}>
                    <tr className="pag-tr">
                      <td style={{ ...tdStyle, fontWeight: '600' }}>{row.label}</td>
                      <td style={{ ...tdStyle, textAlign: 'right', color: '#dc2626', fontWeight: '600' }}>{formatCurrency(row.val)}</td>
                      <td style={{ ...tdStyle, textAlign: 'right' }}>
                        {row.pct !== undefined && (
                          <span style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', padding: '2px 7px', borderRadius: '999px', backgroundColor: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }}>
                            {row.pct?.toFixed(2)}%
                          </span>
                        )}
                      </td>
                    </tr>
                    {row.sub?.map((det, j) => (
                      <tr key={`sub-${i}-${j}`}>
                        <td style={{ ...tdStyle, paddingLeft: '2.5em', color: '#6b7280', fontSize: `calc(12px * var(--font-scale))` }}>{det.descricao}</td>
                        <td style={{ ...tdStyle, textAlign: 'right', color: '#6b7280', fontSize: `calc(12px * var(--font-scale))` }}>{formatCurrency(det.valor)}</td>
                        <td style={tdStyle} />
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
                {/* Total */}
                <tr style={{ backgroundColor: '#eff6ff' }}>
                  <td style={{ ...tdStyle, fontWeight: '700', color: '#2563eb' }}>Total Geral de Custos e Despesas</td>
                  <td style={{ ...tdStyle, textAlign: 'right', fontWeight: '700', color: '#2563eb' }}>{formatCurrency(analiseCustosDespesasData.total_geral_custos_despesas_analisadas)}</td>
                  <td style={tdStyle} />
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </AccordionSection>

      {/* ══ Ticket Médio ══ */}
      <AccordionSection title="Ticket Médio por Paciente" icon={ICONS.ticket}>
        <FilterBar onFilter={fetchTicketMedio} isLoading={isLoadingTicketMedio} filterLabel="Calcular">
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Início</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataInicioTicketMedio} onChange={e => setFiltroDataInicioTicketMedio(e.target.value)} {...focusHandlers} />
          </div>
          <div style={{ minWidth: '150px' }}>
            <FieldLabel>Data Fim</FieldLabel>
            <input style={inputStyle} type="date" value={filtroDataFimTicketMedio} onChange={e => setFiltroDataFimTicketMedio(e.target.value)} {...focusHandlers} />
          </div>
        </FilterBar>

        {isLoadingTicketMedio ? <LoadingRow /> : !ticketMedioData ? (
          <EmptyState message="Selecione o período para calcular o ticket médio." />
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px' }}>
            <KpiCard
              label="Período"
              value={`${new Date(ticketMedioData.periodo.inicio + 'T00:00:00').toLocaleDateString('pt-BR')} – ${new Date(ticketMedioData.periodo.fim + 'T00:00:00').toLocaleDateString('pt-BR')}`}
            />
            <KpiCard label="Faturamento Total" value={formatCurrency(ticketMedioData.faturamento_total)} />
            <KpiCard label="Pacientes Únicos" value={ticketMedioData.numero_pacientes_unicos} />
            <KpiCard
              label="Ticket Médio"
              value={formatCurrency(ticketMedioData.ticket_medio)}
              sub="por paciente no período"
            />
          </div>
        )}
      </AccordionSection>

      {/* ══ Taxa de Retenção ══ */}
      <AccordionSection title="Taxa de Retenção de Pacientes (%)" icon={ICONS.users}>
        {/* Filtros P1 */}
        <div style={{ marginBottom: '10px' }}>
          <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
            Período Anterior (P1)
          </div>
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end',
            padding: '12px 14px', backgroundColor: '#f8fafc', borderRadius: '10px', border: '1px solid #f1f5f9',
          }}>
            <div style={{ minWidth: '150px' }}>
              <FieldLabel>Data Início P1</FieldLabel>
              <input style={inputStyle} type="date" value={filtroDataInicioRetencaoP1} onChange={e => setFiltroDataInicioRetencaoP1(e.target.value)} {...focusHandlers} />
            </div>
            <div style={{ minWidth: '150px' }}>
              <FieldLabel>Data Fim P1</FieldLabel>
              <input style={inputStyle} type="date" value={filtroDataFimRetencaoP1} onChange={e => setFiltroDataFimRetencaoP1(e.target.value)} {...focusHandlers} />
            </div>
          </div>
        </div>

        {/* Filtros P2 */}
        <div style={{ marginBottom: '16px' }}>
          <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
            Período Atual (P2)
          </div>
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end',
            padding: '12px 14px', backgroundColor: '#f8fafc', borderRadius: '10px', border: '1px solid #f1f5f9',
          }}>
            <div style={{ minWidth: '150px' }}>
              <FieldLabel>Data Início P2</FieldLabel>
              <input style={inputStyle} type="date" value={filtroDataInicioRetencaoP2} onChange={e => setFiltroDataInicioRetencaoP2(e.target.value)} {...focusHandlers} />
            </div>
            <div style={{ minWidth: '150px' }}>
              <FieldLabel>Data Fim P2</FieldLabel>
              <input style={inputStyle} type="date" value={filtroDataFimRetencaoP2} onChange={e => setFiltroDataFimRetencaoP2(e.target.value)} {...focusHandlers} />
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <button
                type="button" onClick={fetchTaxaRetencao} disabled={isLoadingTaxaRetencao}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '6px',
                  padding: '8px 16px', borderRadius: '8px', border: 'none',
                  background: isLoadingTaxaRetencao ? '#93c5fd' : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
                  color: '#fff', fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600',
                  cursor: isLoadingTaxaRetencao ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
                }}
              >
                {isLoadingTaxaRetencao
                  ? <Spinner as="span" animation="border" size="sm" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />
                  : <Icon d={ICONS.filter} size={11} color="#fff" />
                }
                {isLoadingTaxaRetencao ? 'Calculando...' : 'Calcular'}
              </button>
            </div>
          </div>
        </div>

        {isLoadingTaxaRetencao ? <LoadingRow /> : !taxaRetencaoData ? (
          <EmptyState message="Selecione os períodos para calcular a taxa de retenção." />
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px' }}>
            <KpiCard
              label="Período Anterior (P1)"
              value={`${new Date(taxaRetencaoData.periodo_anterior.inicio + 'T00:00:00').toLocaleDateString('pt-BR')} – ${new Date(taxaRetencaoData.periodo_anterior.fim + 'T00:00:00').toLocaleDateString('pt-BR')}`}
            />
            <KpiCard
              label="Período Atual (P2)"
              value={`${new Date(taxaRetencaoData.periodo_atual.inicio + 'T00:00:00').toLocaleDateString('pt-BR')} – ${new Date(taxaRetencaoData.periodo_atual.fim + 'T00:00:00').toLocaleDateString('pt-BR')}`}
            />
            <KpiCard label="Pacientes em P1" value={taxaRetencaoData.total_pacientes_periodo_anterior} />
            <KpiCard label="Retornaram em P2" value={taxaRetencaoData.pacientes_retidos_no_periodo_atual} />
            <KpiCard
              label="Taxa de Retenção"
              value={`${taxaRetencaoData.taxa_retencao_percentual.toFixed(1)}%`}
              sub="pacientes que retornaram"
            />
          </div>
        )}
      </AccordionSection>
    </div>
  );
};

export default RelatoriosGerenciaisTab;
